import serverInit from '.'
import { Server as httpServer } from 'http'

export default (param, config): void => {
  if (config) {
    const middleware = config.middleware
    const serverOptions = config.options
    const serverScript = config.script || {}
    const serverObj: httpServer = middleware ? serverOptions : param.httpServer
    config ? serverInit(serverObj, serverOptions, serverScript) : {}
  } else {
    // server(param.server, {}, {}, (() => {/** */ }))
    // const serverObj: httpServer = middleware ? serverOptions : param.server
    // obj.server ? server(serverObj, serverOptions, serverScript, serverCallback) : {}
  }
}